import type { Content } from '@generalTypes/apiTypes';
import type { RootState } from '@generalTypes/rootStateTypes';
import { KovResourcePicker, Modal } from '@kathondvla/react-shared-components/src/components';
import { selectGoalSets } from './goalSetItemModalSelectors';
import { closeGoalSetItemModal } from '@newStore/documentUI/documentUIState';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const GoalSetItemModal: React.FC = () => {
  const dispatch = useDispatch();
  const [selectedGoalSet, setSelectedGoalSet] = useState<Content | null>(null);

  const { open } = useSelector((state: RootState) => state.documentUI.goalSetItemModal);

  const goalSets = useSelector(selectGoalSets);

  if (!open) return null;

  const handleCancel = () => {
    setSelectedGoalSet(null);
    dispatch(closeGoalSetItemModal(null));
  };

  const handleSubmit = () => {
    if (selectedGoalSet) {
      dispatch(closeGoalSetItemModal(selectedGoalSet.$$meta.permalink));
      setSelectedGoalSet(null);
    }
  };

  return (
    <div className="overflown-modal">
      <Modal.Header title="Doelenset kiezen" onClose={handleCancel} />
      <Modal.Body>
        <div className="form-group">
          <label className="control-label">Doelenset</label>
          <div className="row">
            <div className="col-sm-12">
              <KovResourcePicker
                localData={goalSets}
                value={selectedGoalSet}
                onChange={(value: Content) => setSelectedGoalSet(value)}
                clearable={true}
                multiple={false}
                menuPlacement="bottom"
                optionTemplate={(option) => `${option.identifiers?.[0]} ${option.title}`}
                filter={({ data }, str) => {
                  if (!str || str.trim().length === 0) return true;
                  return data.title?.toLowerCase().includes(str.toLowerCase()) ?? false;
                }}
                placeholder="Selecteer een doelenset"
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-link pull-left" onClick={handleCancel}>
          Annuleren
        </button>
        <button className="btn btn-primary" onClick={handleSubmit} disabled={!selectedGoalSet}>
          Ok
        </button>
      </Modal.Footer>
    </div>
  );
};

GoalSetItemModal.displayName = 'GoalSetItemModal';

export default GoalSetItemModal;
